import React, { FC, useContext, useEffect, useRef, useState } from 'react'
import { ALIGN_BUTTONS_AND_LINKS } from '~utils/featureFlags'
import { IUserContextType, UserContext } from '~utils/context/UserContext'
import { Button, Form, FormInput } from '@connectcore/connect-components-react'
import { CallbackType } from '@forgerock/javascript-sdk'
import { LOGIN_FAILURE_SCD_ERROR, USERNAME_REQUIRED_MESSAGE } from '~utils/constants'
import { getErrorTemplate } from '~utils/helpers'

interface IFormData {
  formData: { userName: string | undefined }
  feedback: { userName: string | undefined }
}

const CollectUserNameForm: FC = () => {
  const [formState, setFormState] = useState<IFormData>({
    formData: { userName: undefined },
    feedback: { userName: undefined },
  })
  const [apiError, setApiError] = useState(false)
  const [error, setError] = useState('')
  const { step, nextStep, showErr, userInputError } = useContext(UserContext) as IUserContextType
  let userNameCallBackFn
  const forgotPassUsernameRef = useRef<any>(null)
  if (step?.getCallbacksOfType(CallbackType.NameCallback)?.length > 0)
    userNameCallBackFn = step?.getCallbackOfType(CallbackType.NameCallback)

  const validateAndSetFormData = e => {
    setApiError(false)
    setError('')
    if (Object.keys(e).includes('userName') && !e?.userName?.trim()) {
      const feedback = { userName: USERNAME_REQUIRED_MESSAGE }
      setFormState({ ...formState, feedback: { ...formState.feedback, ...feedback } })
    } else if (Object.keys(e).includes('userName') && e.userName) {
      const feedback = { userName: undefined }
      setFormState({
        ...formState,
        feedback: { ...formState.feedback, ...feedback },
        formData: { ...formState.formData, ...e },
      })
    }
  }

  useEffect(() => {
    setApiError(showErr)
  }, [showErr])

  useEffect(() => {
    setError(userInputError)
  }, [userInputError])

  const submitUserName = () => {
    forgotPassUsernameRef.current.focus()
    setApiError(false)
    setError('')
    const userName = formState.formData.userName?.trim()
    if (userName) {
      userNameCallBackFn?.setInputValue(userName)
      nextStep(step)
    } else {
      const feedback = { userName: USERNAME_REQUIRED_MESSAGE }
      setFormState({ ...formState, feedback: { ...formState.feedback, ...feedback } })
    }
  }

  return (
    <Form
      className="CollectUserNameForm wide-form"
      data-testid="CollectUserNameForm"
      onChange={e => validateAndSetFormData(e)}
      onSubmit={() => submitUserName()}
      key="CollectUserNameForm"
    >
      <h2 className="fw-bold my-5 align-self-center">
        Password change - Step 1 Enter your username
      </h2>
      <FormInput
        className="my-5 w-50"
        name="userName"
        required={true}
        innerRef={forgotPassUsernameRef}
        label="Username"
        feedback={<p role="alert">{formState.feedback.userName}</p>}
        validationState={
          formState.feedback.userName !== undefined && formState.feedback.userName?.length > 0
            ? 'invalid'
            : undefined
        }
      />

      {apiError && (
        <p className="invalid-feedback" role="alert">
          {LOGIN_FAILURE_SCD_ERROR}
        </p>
      )}
      {error && (
        <p className="invalid-feedback" role="alert">
          {getErrorTemplate(error)}
        </p>
      )}

      <div className="d-flex flex-column">
        <Button kind="primary" className={`my-3 align-${ALIGN_BUTTONS_AND_LINKS}`}>
          Next
        </Button>
      </div>
    </Form>
  )
}

export default CollectUserNameForm
